export const AUDIO_ENABLED_STORAGE_KEY = 'profase-crm-audio-enabled';

export function isAudioEnabled(): boolean {
  try {
    const value = localStorage.getItem(AUDIO_ENABLED_STORAGE_KEY);
    if (value === null) return true;
    return value === 'true';
  } catch {
    return true;
  }
}

export function persistAudioEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(AUDIO_ENABLED_STORAGE_KEY, String(enabled));
  } catch {
    /* ignore quota / private mode */
  }
}

export function playSound(src: string, volume?: number): void {
  if (!isAudioEnabled()) return;
  try {
    const audio = new Audio(src);
    if (volume != null) audio.volume = volume;
    void audio.play().catch(() => {});
  } catch {
    /* ignore */
  }
}

/** Evita bloqueos de autoplay tras handlers async (p. ej. fetch). */
export function playSoundDeferred(src: string, delayMs = 0): void {
  window.setTimeout(() => playSound(src), delayMs);
}

export function resolveActividadEstado(data?: Record<string, unknown> | null): string {
  if (!data) return '';
  const candidates = [
    data.estado,
    data.nodoEstado,
    (data.data as Record<string, unknown> | undefined)?.estado,
    (data.actividad as Record<string, unknown> | undefined)?.estado,
  ];
  for (const candidate of candidates) {
    const normalized = String(candidate ?? '').trim().toUpperCase();
    if (normalized) return normalized;
  }
  return '';
}

export function isPendienteToPendienteAutorizacion(
  fromEstado?: string | null,
  toEstado?: string | null,
): boolean {
  const from = String(fromEstado ?? '').toUpperCase();
  const to = String(toEstado ?? '').toUpperCase();
  return from === 'PENDIENTE' && to === 'PENDIENTE_DE_AUTORIZACION';
}

export function isFinalizadoToEnProceso(
  fromEstado?: string | null,
  toEstado?: string | null,
): boolean {
  const from = String(fromEstado ?? '').toUpperCase();
  const to = String(toEstado ?? '').toUpperCase();
  return from === 'FINALIZADO' && to === 'EN_PROCESO';
}

const FINALIZADO_WRONG_SOUND_TARGETS = new Set([
  'EN_PROCESO',
  'PENDIENTE',
  'PENDIENTE_DE_AUTORIZACION',
  'NO_AUTORIZADO',
  'BLOQUEADO',
]);

export function shouldPlayWrongSoundOnFinalizadoTransitionError(
  fromEstado?: string | null,
  toEstado?: string | null,
): boolean {
  const from = String(fromEstado ?? '').toUpperCase();
  const to = String(toEstado ?? '').toUpperCase();
  return from === 'FINALIZADO' && FINALIZADO_WRONG_SOUND_TARGETS.has(to);
}
